

































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Helper } from '@/helpers/Helper'
import PageHead from '@/components/PageHead.vue'
import TinyMCE from '@/components/TinyMCE.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import store from '@/store'
import type { RightBarGlobalSettings, RightBar } from '@/interfaces'

@Component({
  components: {
    TinyMCE,
    PageHead,
  },
})
export default class RightSideBar extends Vue {
  pageTitle = 'Right Side Bar'
  callInProgress = false
  featuredImageSelected = false
  dynamicBlocks: RightBar[] = null
  rightBarGlobalSettings: RightBarGlobalSettings = null
  domainRightBar = null
  domainImages = null
  systemImages = null
  urlScheme = window.location.protocol
  globalSettingInfo = 'Change will be reflected in "Global Settings" as well!'
  twitterUsernameInfo = 'Provide Twitter username to enable Latest Tweets. Change will be reflected in "Social Media Settings" as well!'
  aorInfo = 'Provide AOR key to display AOR seal in right side bar.'

  get Helper() {
    return Helper
  }

  mounted() {
    this.fetchDomainRightBar()
  }

  public async fetchDomainRightBar() {
    this.callInProgress = true
    try {
      const domainRightBar = await Api.getDomainRightBar()
      this.dynamicBlocks = domainRightBar.dynamicBlocks
      this.rightBarGlobalSettings = domainRightBar.rightBarGlobalSettings
      this.featuredImageSelected = this.rightBarGlobalSettings.featuredImage !== ''
      // this.callInProgress = false
      this.fetchDoaminImages()
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async setDomainRightBar() {
    this.callInProgress = true
    try {
      await Api.setDomainRightBar(this.dynamicBlocks, this.rightBarGlobalSettings)
      this.callInProgress = false
      store.commit('toggleFlag')
      Notify.create({
        type: 'success',
        title: 'Saved!',
        text: 'Right Bar Elements Saved.',
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public pushToDynamicBlocks() {
    this.dynamicBlocks.push({
      id: null,
      order: this.getNextOrder(),
      heading: null,
      class: 'side whatsnew',
      content: '<div class="SIDETEXT para"></div>',
    })
    return false
  }

  public getNextOrder() {
    let nextOrder = 0
    for (const whatsNewData of this.dynamicBlocks) {
      nextOrder = whatsNewData.order > nextOrder ? whatsNewData.order : nextOrder
    }

    return ++nextOrder
  }

  public deleteWhatsNew(whatsNewData) {
    for (const [index, whatsNewDetails] of this.dynamicBlocks.entries()) {
      if (whatsNewData.id === whatsNewDetails.id) {
        this.dynamicBlocks.splice(index, 1)
      }
    }
  }

  public changeItem(event) {
    // console.log(event.target.value)
    this.featuredImageSelected = (event.target.value !== '')
    // this.rightBarGlobalSettings.featuredImage = this.urlScheme + '//' + Helper.getCurrentDomain() + '/images/' + event.target.value
    this.rightBarGlobalSettings.featuredImage = event.target.value
  }

  public updateContent(content, title) {
    for (const blockDetails of this.dynamicBlocks) {
      if (blockDetails.heading === title) {
        blockDetails.content = content
      }
    }
    // console.log(title)
    // console.log(content)
  }

  public async fetchDoaminImages() {
    this.callInProgress = true
    try {
      const domainImagesResponse = await Api.getDomainImages()
      this.domainImages = domainImagesResponse.domainImages
      this.systemImages = domainImagesResponse.systemImages
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public updateContactAddress(content) {
    this.rightBarGlobalSettings.contactAddress = content
  }
}
